import script from "./myOrderPage3.vue?vue&type=script&setup=true&lang=js"
export * from "./myOrderPage3.vue?vue&type=script&setup=true&lang=js"

import "./myOrderPage3.vue?vue&type=style&index=0&id=312ea541&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-312ea541"]])

export default __exports__